<script type="text/javascript">
    import { http } from '../../http';
    import Apps from '../../../core/Apps';
    import Events from '@/core/Events'
    import ClientTabs from 'Components/client/ClientTabs'

    export default {
        data() {
            return {
                user_log: [],
                current_offset: 0,
                show_more_button_loading: false,
                has_show_more_been_clicked: false,
                show_more_button: true,
                loading: false,
                booking_id: false,
                hasLoadedUserLog: false,
            }
        },

        props: {
            client_id : {
                default: false
            },

            creditnote_id: {
                default: false,
            },

            invoice_id : {
                default: false
            },

            event_id : {
                default: false,
            },

            event_group_id: {
                default: false,
            },

            load_timeline : {
                default: 1
            },
        },

        mounted() {
            if (this.load_timeline) {
                this.getUserLog(true);
            }

            this.$event_bus.$on(Events.Client.TabChanged, tab => {
                if (tab === ClientTabs.Notifications) {
                    this.getUserLog();
                }
            });

            this.$event_bus.$on('reloadTimeline', () => {
                this.user_log = [];
                this.current_offset = 0;
            });

            this.$event_bus.$on('showDigitalContentPackage', (data) => {
                window.location.href = `/app/online-courses/${data.id}`
            })

            this.$event_bus.$on('showBookingHistory', (booking) => {
                $('#booking-history-modal').modal('show');
                this.booking_id = booking.id;
                this.user_log = [];
                this.current_offset = 0;
                this.getUserLog(true);
            });

            this.$event_bus.$on('reloadTimeline', () => {
                this.user_log = [];
                this.current_offset = 0;
                this.getUserLog(true);
            });

            $('#booking-history-modal').on('hide.bs.modal', () => {
                this.resetTimeline();
            });
        },

        methods: {
            getUserLog(reload = false) {
                if (reload) {
                    this.hasLoadedUserLog = false;
                }

                if (!this.hasLoadedUserLog) {
                    let data = { 'offset' : this.current_offset};

                    if (!this.has_show_more_been_clicked) {
                        this.loading = true;
                    }

                    let url = '/app/userlog';
                    if (this.client_id) {
                        url += '/client/' + this.client_id;
                    } else if (this.invoice_id) {
                        url += '/invoice/' + this.invoice_id;
                    } else if (this.creditnote_id) {
                        url += '/creditnote/' + this.creditnote_id;
                    } else if (this.event_id) {
                        url += '/event/' + this.event_id;
                    } else if (this.booking_id) {
                        url += '/booking/' + this.booking_id;
                    } else if (this.event_group_id) {
                        url += '/event-group/' + this.event_group_id;
                    }

                    this.show_more_button_loading = true;

                    this.hasLoadedUserLog = true;

                    http.get(url, {params : data }  )
                        .then(({ data }) => {
                            this.user_log = this.user_log.concat(data);

                            if(data.length < 5){
                                this.show_more_button = false;
                            }

                            this.show_more_button_loading = false;
                        })
                        .catch(({ error, errorBag }) => {
                            this.show_more_button_loading = false;

                            this.hasLoadedUserLog = false;
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },

            resetTimeline() {
                this.user_log = [];
                this.current_offset = 0;
                this.show_more_button_loading = false;
                this.has_show_more_been_clicked = false;
                this.show_more_button = true;
                this.loading = false;
                this.booking_id = false;
            },

            showRelatedUrl(url) {
                if (url.type === 'client' && this.client_id) {
                    return false;
                }
                if (url.type === 'invoice' && this.invoice_id) {
                    return false;
                }
                if (url.type === 'booking' && this.booking_id) {
                    return false;
                }

                return true;
            },

            showMoreEntries() {
                this.current_offset = this.current_offset + 5;
                this.has_show_more_been_clicked = true;
                this.getUserLog(true);
            },

            emit(related_url) {
                $('#all-notifications-modal').modal('hide');

                setTimeout(() => {
                    if (related_url.emit.data) {
                        this.$event_bus.$emit(related_url.emit.event, ...related_url.emit.data);
                    } else {
                        this.$event_bus.$emit(related_url.emit.event);
                    }
                }, 500);
            },

            resendEmail(email) {
                this.loading = true;

                http.post(`/app/email/${email.id}/resend`)
                    .then(({ data }) => {
                        email.status = 0;
                    })
                    .catch(({ error }) => {})
                    .finally(() => {
                        this.loading = false;
                    })
            },

            editClient() {
                this.$event_bus.$emit('showEditClient', {'id': this.client_id});
            }
        },

        watch: {
            load_timeline: {
                handler(val, oldVal) {
                    if (val) {
                        this.getUserLog(true);
                    }
                }
            }
        },

        computed: {
            user_log_filtered() {
                return this.user_log;
            },

            is_user_management_enabled() {
                return this.$store.getters['apps/isAppEnabled'](Apps.UserManagement)
                    || this.$store.getters['apps/isAppEnabled'](Apps.Tenants);
            },

            can_edit_client() {
                return this.$can('edit', 'client', this.client_id);
            },
        }
    };
</script>

<template id="timeline">
   <div class="timeline-wrapper" ref="timelinewrapper">
       <ul class="timeline" :class="{ 'fully-loaded' : !show_more_button }" v-if="user_log.length > 0">
           <li :class="{ 'timeline-inverted' : index % 2 }" v-for="(log, index) in user_log_filtered" :key="index">
               <div class="timeline-badge"><i class="zmdi" :class="log.material_icon"></i></div>
               <div class="timeline-panel card-box bg-box">
                   <div class="timeline-heading">
                   </div>
                   <div class="timeline-body">
                       <small class="text-muted truncate m-b-5">
                           <span v-if="log.new" class='new-log-entry pull-right'>{{ trans('user.new_event') }}</span>
                           {{ log.date_formatted }}
                           <span v-if="log.related_user && is_user_management_enabled"> &middot; <i class="zmdi zmdi-account"></i> {{ log.related_user.realname }}</span>
                       </small>

                        <p>{{ log.text }}</p>

                        <div class="alert alert-warning p-5" v-if="log.email && log.email.status >= 3">
                            <p class="small">{{ trans(`client.email_status_${log.email.status}`) }}</p>

                            <div class="related-urls">
                                <!-- The client's email is invalid -->
                                <small class="related-url" v-if="log.email.status === 4 && can_edit_client">
                                    <a href="#" @click="editClient()">{{ trans('calendar.edit_client') }}</a>
                                </small>

                                <small class="related-url">
                                    <a v-if="!loading" href="#" @click="resendEmail(log.email)">{{ trans('client.resend') }}</a>
                                    <em v-else>{{ trans('client.resending') }}...</em>
                                </small>
                            </div>
                        </div>

                        <div class="related-urls">
                            <template v-for="(related_url, url_index) in log.related_urls">
                                <small class="related-url" v-if="log.related_urls.length > 0 && showRelatedUrl(related_url)" :key="url_index">
                                     <a v-if="related_url.url && !related_url.emit" :href="related_url.url" :class="{ 'show-in-popup' : related_url.async }">{{ related_url.label }} </a>
                                     <em v-if="!related_url.url && !related_url.emit">{{ related_url.label }}</em>
                                     <a v-if="related_url.emit" href="javascript:void(0);" @click="emit(related_url)">{{ related_url.label }}</a>
                                </small>
                            </template>
                        </div>
                    </div>
                </div>
            </li>

            <li class="timeline-fetch-more" v-if="show_more_button">
                <div v-if="show_more_button_loading" class="preloader m-0" style="width:34px;height:34px;"></div>
                <a href="" v-on:click.prevent="showMoreEntries()" class="btn btn-custom"  v-if="!show_more_button_loading">
                    <i class="zmdi zmdi-caret-down m-r-5"></i> {{ trans('client.show_more') }}
                </a>
            </li>

            <li class="timeline-ended" v-if="!show_more_button">
                 <span><i class="zmdi zmdi-circle"></i></span>
            </li>
        </ul>

        <div class="empty-state" v-if="user_log.length == 0 && !loading">
            <span class="text-muted" v-if="client_id"><i class="ti ti-rss-alt m-r-10"></i> {{ trans('client.follow_client_events') }}</span>
            <span class="text-muted" v-else><i class="ti ti-rss-alt m-r-10"></i> {{ trans('global.no_events_yet') }}</span>
        </div>

        <div v-if="loading">
            <div class="text-center">
                <div class="preloader"></div>
            </div>
        </div>
    </div>
</template>
